import { type ErrorCode } from "@models/enums/error.codes";
import { ErrorBase } from "./error-base.model";

export class GenericError<T> extends ErrorBase {
    errorObject?: T;
    date?: Date;
    location?: string;
    message: string;
    errorCode: ErrorCode;
    constructor();
    constructor(objectInitializer: Pick<GenericError<T>, keyof GenericError<T>>)
    constructor(objectInitializer?: Pick<GenericError<T>, keyof GenericError<T>>) {
        super();
        if(objectInitializer) {
            Object.assign(this, objectInitializer);
        }
        if(!this.date) {
            this.date = new Date();
        }
    }
}